export const ExperimentAPINames = {
  ContextualPaywallMessaging: "Contextual Paywall Messaging",
  HigherPaywall: "Higher Paywall",
  LTSHardPaywall: "LTS 70 Hard Paywall",
  NewSearchBackend: "New Search Backend",
  PaywallMasking: "Paywall Masking",
  VelocityWallThreshold: "Velocity Wall Threshold",
};
